import { useEffect, useState } from "react";
import api from "../utils/axiosInstance";
import DeviceModal from "../components/DeviceModal";
import "../styles/DeviceList.css";

const DeviceList = () => {
    const [devices, setDevices] = useState([]);
    const [error, setError] = useState("");
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedDevice, setSelectedDevice] = useState(null);
    const [skuFilter, setSkuFilter] = useState("");
    const [nameFilter, setNameFilter] = useState("");
    const [availableFilter, setAvailableFilter] = useState("all"); // 'all', 'yes', 'no'


    useEffect(() => {
        fetchDevices();
    }, []);

    const filteredDevices = devices.filter((device) => {
        const matchesSku = device.sku.toLowerCase().includes(skuFilter.toLowerCase());
        const matchesName = device.name.toLowerCase().includes(nameFilter.toLowerCase());

        const matchesAvailable =
            availableFilter === "all" ||
            (availableFilter === "yes" && device.available) ||
            (availableFilter === "no" && !device.available);

        return matchesSku && matchesName && matchesAvailable;
    });


    const fetchDevices = async () => {
        try {
            const response = await api.get("/devices");
            setDevices(response.data);
        } catch (err) {
            setError("Devices loading error");
        }
    };

    const openEditModal = (device) => {
        setSelectedDevice(device);
        setModalOpen(true);
    };

    const handleDuplicate = (device) => {
        const { id, image_url, ...rest } = device;
        setSelectedDevice({
            ...rest,
            sku: "",
            image: null,
            image_url: "",
            published: false,
            published_at: "",
        });
        setModalOpen(true);
    };


    const handleDelete = async (id) => {
        if (!window.confirm("Delete device?")) return;

        try {
            await api.delete(`/devices/${id}`);
            fetchDevices();
        } catch (err) {
            setError("Device deletion error");
        }
    };

    return (
        <div className="device-container">
            <h1>📦 Device catalog</h1>
            {error && <p className="text-red-500">{error}</p>}

            <button onClick={() => setModalOpen(true)} className="add-device-button">
                ➕ Add device
            </button>

            <div className="device-filters">
                <input
                    type="text"
                    placeholder="Filter by SKU"
                    value={skuFilter}
                    onChange={(e) => setSkuFilter(e.target.value)}
                />
                <input
                    type="text"
                    placeholder="Filter by Name"
                    value={nameFilter}
                    onChange={(e) => setNameFilter(e.target.value)}
                />
                <select
                    value={availableFilter}
                    onChange={(e) => setAvailableFilter(e.target.value)}
                >
                    <option value="all">All Availability</option>
                    <option value="yes">Available</option>
                    <option value="no">Not Available</option>
                </select>
            </div>


            <div className="table-scroll-wrapper">
            <table className="device-table">
                <thead>
                <tr>
                    <th>ID</th>
                    <th>SKU</th>
                    <th>Name</th>
                    <th>Image</th>
                    <th>Available</th>
                    <th>Publish status</th>
                    <th>Publish date</th>
                    <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                {filteredDevices.map((device) => (
                    <tr key={device.id}>
                        <td>{device.id}</td>
                        <td>
                            <span
                                className="clickable-cell"
                                onClick={() => openEditModal(device)}
                            >
                                {device.sku}
                            </span>
                        </td>
                        <td>
                            <span
                                className="clickable-cell"
                                onClick={() => openEditModal(device)}
                            >
                                {device.name}
                            </span>
                        </td>
                        <td>
                            {device.image_url ? <img src={device.image_url} alt={device.name}
                                                     className="device-img"/> : "No image"}
                        </td>
                        <td>{device.available ? "Yes" : "No"}</td>
                        <td>{device.published ? "Yes" : "No"}</td>
                        <td>{device.published_at ? new Date(device.published_at).toLocaleString() : "—"}</td>

                        <td className="device-actions">
                            <button
                                className="edit-button"
                                onClick={() => openEditModal(device)}
                            >
                                ✏️ Edit
                            </button>
                            <button
                                className="duplicate-button"
                                onClick={() => handleDuplicate(device)}
                            >
                                📄 Duplicate
                            </button>
                            <button
                                className="delete-button"
                                onClick={() => handleDelete(device.id)}
                            >
                                🗑️ Delete
                            </button>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
            </div>

            {/* Модальное окно */}
            <DeviceModal
                isOpen={isModalOpen}
                onClose={() => {
                    setModalOpen(false);
                    setSelectedDevice(null);
                }}
                onSave={fetchDevices}
                device={selectedDevice}
                devices={devices}
            />
        </div>
    );
};

export default DeviceList;
